
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","viewBox":"0 0 100 100","fill":"636569","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMinYMax meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M90.1 38.1c-1.3-1.3-3-2-4.9-2H24.7V19c0-2.9 2.6-5.5 5.5-5.5s5.5 2.6 5.5 5.5c0 1.3.9 2.3 2.2 2.3 1.3 0 2.2-.9 2.2-2.3 0-5.5-4.5-10-10-10S20.2 13.4 20 19v17h-2.2C14 36 11 39 11 42.8c0 2.7 1.7 5.2 4.2 6.3l.3.2v10.2c0 7.2 5 13.6 12.2 15.5l.6.1-2.3 3.8c-.2.3-.4 1.1-.2 1.7.2.6.7 1 1 1.2.4.4.9.4 1.2.4.8 0 1.5-.4 1.9-1.1l3.4-5.9h36.3l3.3 5.9c.4.7 1.1 1.2 1.9 1.2.6 0 .9-.2 1.2-.5.4-.3.8-.8.9-1.3.2-.6 0-1.1-.1-1.6v-.1L74.5 75l.6-.1c7.2-1.8 12.2-8.2 12.2-15.5v-10l.4-.2c2.6-1.1 4.2-3.6 4.2-6.3.1-1.9-.6-3.6-1.8-4.8zM83 49.9v9.6C83 65.8 77.9 71 71.6 71H31.5C25.2 70.9 20 65.7 20 59.4v-9.6h63v.1zm-67.5-7.1c0-1.3 1-2.3 2.3-2.3h67.5c1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3H17.8c-1.3 0-2.3-1.1-2.3-2.3z"}})])
          )
        }
      }
    